import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import PageHeader from "../PageHeader";
import CandidateList from "./CandidateList";
import CandidatePay from "./CandidatePay";
import http from "../../services/HttpService";
import config from "../../config.json";
import AddNewTimeLog from "./AddNewTimeLog";
import AddEditNotes from "./AddEditNotes";
import UploadInvoice from "./UploadInvoice";
import Swal from "sweetalert2";
import { getAllMonths, getAllYears, getFieldData, getFormatedNumber, getMonthLastDay, getMonthName, getTotalDays, getTotalHours } from "../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAlert } from "../../services/appAlerts";
import { getTimeLogInvoice, loadTimeLogInvoice } from "../../app/store/timeLogInvoice";
import { getTimeLogDuration, getTimeLogs, loadTimeLogDuration, loadTimeLogs } from "../../app/store/timeLog";
import InvoiceReview from "./InvoiceReview";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import ViewCandidate from "./ViewCandidate";
import WorkflowElement from "../../app/components/WorkflowElement";
import { candidateBprmFormReceived, getCandidateBprmForm, loadCandidateBprmForm } from "../../app/store/candidate";

export default function CandidateInvoice(props) {
  const { mainItem, type, module } = props;

  const route = [
    { name: "Onboarding and Contracts", url: "" },
    {
      name: `${module === "Recruiter" ? "Recruiters" : "Subcontractors"}`,
      url: "/ListSubcontractor/application",
    },
    { name: "Work In Progress", url: "/CustomerApps" }
    // {
    //   name: `${module === "Recruiter" ? "Recruiter" : "Subcontractor"
    //     } Details`,
    //   url: "/ReviewTask",
    //   state: { item: mainItem, type, module },
    // },
  ];

  const [timeLogs, setTimeLogs] = useState([]);
  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [invoiceType, setInvoiceType] = useState("subcontractor");
  const [timeLogObj, setTimeLogObj] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [candidateObj, setCandidateObj] = useState(null);
  const [rate, setRate] = useState(0);
  const [rateDate, setRateDate] = useState(null);
  const [perfData, setPerfData] = useState("");
  const [invRevShowHide, setInvRevShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [timeLogShowHide, setTimeLogShowHide] = useState(false);
  const [notesType, setNotesType] = useState("TimeLog");
  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  const [selectedObj, setSelectedObj] = useState("");
  const [viewType, setViewType] = useState("");
  const [editDurType, setEditDurType] = useState("");
  const [selectedKey, setSelectedKey] = useState(-1);
  const [viewShowHide, setViewShowHide] = useState(false);
  const [w2Type, setW2type] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfId, setWfId] = useState(0);

  const [viewFormType, setViewFormType] = useState("");
  const [entityType, setEntityType] = useState(null);
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [updatedStateData, setUpdatedStateData] = useState(null);

  const timeLogSelector = useSelector(getTimeLogs);
  const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);

  const years = getAllYears();
  const months = getAllMonths();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Invoice Detail"));
    //dispatch(setCurrentRoute(route));
  }, [])

  useEffect(() => {
    const state = location.state;
    let revewRoute = {
      name: "Review Workflow Task", url: "/ReviewTask", state: {
        task: state?.task,
        item: state?.mainItem,
        app: state?.app,
        type: 1,
        parentApplication: state?.parentApplication,
        appType: state?.appType,
        module: state?.module,
      }
    }
    const newRoute = [...route, revewRoute]
    dispatch(setCurrentRoute(newRoute));

    if (state?.item?.performerid) {
      setCandidateObj(state.item);
      setPerfData(state.item.performerData);
      dispatch(loadTimeLogs(state.item.performerid));
      dispatch(loadTimeLogInvoice(state.item.performerid));
      dispatch(loadTimeLogDuration(state.item.performerid));
    }
    if (state?.module === "Recruiter") {
      setInvoiceType("recruiter");
      if (state?.item?.rates) {
        setRate(state.item.rates.recruiterRate);
        setRateDate(state.item.rates.recruiterEffectiveDate);
      }
    }
    else {
      if (state?.item?.rates) {
        setRate(state.item.rates.subcontractorRate);
        setRateDate(state.item.rates.subcontractorEffectiveDate);
      }
    }
  }, []);

  useEffect(() => {
    if (timeLogSelector.length > 0)
      setTimeLogs(timeLogSelector);

    if (timeLogsInvoiceSelector.length > 0) {
      const filterInvoice = timeLogsInvoiceSelector.filter(x => x.invoiceType === invoiceType);
      setTimeLogInvoices(filterInvoice);
    }

     if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate() + 1); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      console.log(result);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }

  }, [timeLogSelector, timeLogsInvoiceSelector,timeLogDurationSelector]);

  useEffect(() => {

    let filterTimeLogs = [...timeLogSelector];
    if (filterYear > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

    if (filterMonth > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

    setTimeLogs(filterTimeLogs);

  }, [filterMonth, filterYear])

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs || obj?.workingHrs === "") return "";
    const wt = JSON.parse(obj.workingHrs);
    const sortWt = wt.sort((a, b) => new Date(a.start) - new Date(b.start));
    if (sortWt.length > 0) {
      return (
        <div>
          <Moment format="MM/DD/YYYY">{sortWt[0].start}</Moment>-
          <Moment format="MM/DD/YYYY">
            {sortWt[sortWt.length - 1].type === "m"
              ? getMonthLastDay(sortWt[sortWt.length - 1].start)
              : sortWt[sortWt.length - 1].start}
          </Moment>
        </div>
      );
    } else {
      return "";
    }
  };

  const getFinalAmout = (obj) => {
    let fAmt = parseFloat(getInvoiceAmount(obj));
    const invItems = timeLogInvoices.filter(
      (x) => x.timeLogId === obj.id
    );
    if (invItems.length > 0) {
      const item = invItems[0];
      if (item?.adjustmentMinues > 0)
        fAmt -= item.adjustmentMinues;
      if (item?.adjustmentPlus > 0)
        fAmt += item.adjustmentPlus;
      if (item?.adpDeduction > 0)
        fAmt -= item.adpDeduction;
      return parseFloat(fAmt).toFixed(2);
    } else {
      return parseFloat(fAmt).toFixed(2);
    }
  };

  const getInvoiceAmount = (item) => {
    let invAmt = getTotalHours(item?.workingHrs) * rate;
    if (entType !== "W2 Basis") return parseFloat(invAmt).toFixed(2);
    const taxRate = getFieldData(perfData, "candidateonboardingform", "Tax") / 100;
    invAmt += invAmt * taxRate;
    return parseFloat(invAmt).toFixed(2);
  };

  const getInvoiceDocs = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id && x.invDoc !== null
      );
    if (tmLogs.length === 0) return "";

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map((inv) => (
          <React.Fragment>
            {inv.invoiceNumber}
            <br />
            <button
              className="btn btn-sm btn-link pl-0"
              onClick={() => handleDownloadFile(inv.invDoc)}
            >
              {inv.invDoc.documentName}
            </button>
          </React.Fragment>
        ))}
      </>
    }

  }

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.status !== null
      )

    if (tmLogs.length === 0) return "";

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map((inv) => (
          <React.Fragment>
            {inv.status === true && (
              <button
                className="btn btn-sm btn-link text-left pl-0 w-100"
              >
                Approved
              </button>
            )}
            {inv.status === false && (
              <button
                className="btn btn-sm btn-link text-left pl-0 w-100"
              >
                Rejected
              </button>
            )}
            <br />
            <Moment format="MMM Do YYYY">
              {inv.reviewDateTime}
            </Moment>
          </React.Fragment>
        ))}
      </>
    }

  }

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === item.id &&
        x.paymentMode !== null
    );

    if (tmLogs.length === 0) {
      return <button
        className="btn btn-link btn-sm pl-0"
        onClick={() => handlePayShowHide(item)}
      >
        To Pay
      </button>
    }

    return <>
      {tmLogs.map((pay) => (
        <React.Fragment>
          <button
            className="btn btn-link btn-sm pl-0"
            onClick={() => handlePayShowHide(item)}
          >
            {pay.paymentMode !== null
              ? "Paid By IPCS"
              : "To Pay"}
          </button>
          <br />
          {pay?.docList?.map((doc) => (
            <button
              className="btn btn-sm btn-link p-0"
              onClick={() =>
                handleDownloadFile(
                  doc
                )
              }
            >
              {doc.documentName}
            </button>
          ))}

          {pay?.docList?.length > 0 && <br />}
          <Moment format="MMM Do YYYY, h:mm a">
            {pay.payDateTime}
          </Moment>
          <br />
          Paid : {parseFloat(pay.paidAmount).toFixed(2)}
        </React.Fragment>
      ))}
    </>
  }

  const getDueAmountStatus = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.paidAmount !== null
      );
    if (tmLogs.length === 0) return "";

    return <>
      {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
    </>

  }

  const handleInvRevShowHide = (obj) => {
    if (obj === "save") {
      setInvRevShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj?.performerid))
    }
    else {
      setInvRevShowHide(!invRevShowHide);
      setTimeLogObj(obj);
    }
  };

  const handleShowHide = async (obj) => {
    if (obj === "save") {
      setTimeLogShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogs(candidateObj.performerid));
    } else {
      setTimeLogShowHide(!timeLogShowHide);
      setTimeLogObj(obj);
    }
  };

  const handlePayShowHide = async (obj) => {
    if (obj === "save") {
      setPayShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj.performerid))
    } else {
      if (obj === "close") {
        setPayShowHide(false);
        setTimeLogObj("");
      } else {
        const chkInvoice = timeLogInvoices.filter(
          (x) =>
            x.timeLogId === obj.id && x.invDoc !== null
        );
        // if (chkInvoice.length > 0 || entType !== "C2C Basis") {
        if (chkInvoice.length > 0) {
          setPayShowHide(!payShowHide);
          setTimeLogObj(obj);
        } else {
          getAlert("", "Invoice not generated", "error");
        }
      }
    }
  };

  const handleDownloadFile = async (item) => {
    try {
      const { data } = await http.get(config.DownloadDocument + item.id, {
        responseType: "blob",
      });
      if (data.size > 0) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", item.documentName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAdminAgencyFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee"
    );

    const feeDo = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee_Amount"
    )

    if (feePer !== "" && feePer !== "0") {
      return <>State Admin Fee : <b>{feePer}%</b></>
    }
    else if (feeDo !== "" && feeDo !== "0") {
      return <>State Admin Fee : <b>${feeDo}/hr</b></>
    }

    return "";
  }

  const handleNoteShowHide = (obj, type) => {
    if (type === "save") {
      setTimeLogObj("")
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  let item = "";
  let entType = "";
  if (candidateObj) {
    item = candidateObj;
    getFieldData(
      item.performerData,
      "candidateonboardingform",
      "CandidateEntity"
    );
  }

  const handleViewShowHide = (view) => {
    // setSelectedCurrentTask("")
    setWfForm(null)
    // setEditDurType("");
    // setSelectedApp(null);
    // setEditDurType("");
    if (viewType === view) {
      setViewShowHide(false);
      setViewType("");
    } else {
      setViewType(view);
      setViewShowHide(true);
    }
  };

  const handleDurationShowHide = (obj, type, key) => {
    if (viewType === type) {
      setViewShowHide(false);
      setViewType("");
    }
  }

  const setCandidateType = (entType) => {

    let appCiid = 0;
    if (candidateObj?.applications?.length > 0) {
      const allWfTasks = candidateObj?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }

    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis))
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis))
    }
  }

  useEffect(() => {
    if (candidateObj) {
      setUpdatedStateData(candidateObj.performerData)
    } else {
      setUpdatedStateData(null);
    }
  }, [candidateObj])

  useEffect(() => {
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector])


  const handleViewcandidateForm = (type, item) => {
    setViewType("")
    if (viewFormType === type) {
      setViewFormType("");
      setWfForm(null)
      dispatch(candidateBprmFormReceived(null));
    } else {
      setViewFormType(type);
      setCandidateObj(item);
      const entType = getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity");
      const w9type = getFieldData(item.performerData, "candidateonboardingform", "w9_Type");
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
    }
  }

  const handleNextTask = () => {
    console.log("")
  }

  return (
    <React.Fragment>
      {/* <PageHeader
        route={route}
        parentTitle="Candidate Invoice Detail"
        headerTitle="Candidate Invoice Detail"
      ></PageHeader> */}
      <div className="col-md-12">
        <div className="text-right mb-2">
          <button
            className="btn btn-sm btn-outline-default btn-min-width"
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left mr-2"></i>Back
          </button>
        </div>
        <div className="card mb-4 shadow-none">
          <div className="row">
            <div className="col-md-12 form-group">
              {item !== "" && (
                <div className="table-responsive">
                  <table className="table align-items-center table-flush table-hover table-striped mb-2 border">
                    <thead className="thead-light">
                      <tr>
                        <th>CANDIDATE #<br />IPCS ID</th>
                        <th>Candidate Details</th>
                        <th>Entity Type</th>
                        <th>Agency / Client</th>
                        <th>Duration</th>
                        <th>Onboarding Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {item.performerid}
                          <br />
                          {item.maxloans}
                        </td>
                        <td>
                          <button
                            onClick={() => handleViewcandidateForm("Candidate", item)}
                            className="btn p-0 btn-link btn-sm text-uppercase">
                            {item.performername} {item.lastName}
                          </button>
                          <br />
                          {item.performeremail}
                          <br />
                          {item.contactNo && getFormatedNumber(item.contactNo)}
                          <br />
                          {getFieldData(
                            item.performerData,
                            "projectengagement",
                            "PositionTitle"
                          )}
                        </td>
                        <td className="pb-0">
                          {getFieldData(
                            item.performerData,
                            "candidateonboardingform",
                            "CandidateEntity"
                          ) === "1099 Basis" && "1099"}
                          {getFieldData(
                            item.performerData,
                            "candidateonboardingform",
                            "CandidateEntity"
                          ) === "C2C Basis" && "C2C"}
                          {getFieldData(
                            item.performerData,
                            "candidateonboardingform",
                            "CandidateEntity"
                          ) === "1099 Basis" &&
                            type !== "partner" && (
                              <>
                                <br /> Rate :{" "}
                                <b>
                                  $
                                  {
                                    item?.rates?.candidateRate ?
                                      item?.rates?.candidateRate : "0.00"
                                  }
                                  {/* {
                                    getFieldData(
                                      item.performerData,
                                      "candidateonboardingform",
                                      "Rate_hour_Paid_to_Candidate"
                                    ) ?
                                      getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "Rate_hour_Paid_to_Candidate"
                                      ) :
                                      "0.00"
                                  } */}
                                  /Hr
                                </b>
                              </>
                            )}
                          {getFieldData(
                            item.performerData,
                            "candidateonboardingform",
                            "CandidateEntity"
                          ) === "W2 Basis" && (
                              <>
                                {getFieldData(
                                  item.performerData,
                                  "candidateonboardingform",
                                  "w9_Type"
                                )}
                                {type !== "partner" && (
                                  <>
                                    <br /> Rate :{" "}
                                    <b>
                                      $
                                      {
                                        item?.rates?.candidateRate ?
                                          item?.rates?.candidateRate : "0.00"
                                      }
                                      {/* {
                                        getFieldData(
                                          item.performerData,
                                          "candidateonboardingform",
                                          "Rate_hour_Paid_to_Candidate"
                                        ) ?
                                          getFieldData(
                                            item.performerData,
                                            "candidateonboardingform",
                                            "Rate_hour_Paid_to_Candidate"
                                          ) :
                                          "0.00"
                                      } */}
                                      /Hr
                                    </b>
                                    <br />
                                    {
                                      getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "Per_Diem_Rate"
                                      ) ? (
                                        <>
                                          Per Diem Rate :{" "}

                                          <b>
                                            $
                                            {getFieldData(
                                              item.performerData,
                                              "candidateonboardingform",
                                              "Per_Diem_Rate"
                                            )}
                                            /Day
                                          </b>

                                        </>
                                      ) : ""
                                    }

                                  </>
                                )}
                              </>
                            )}
                        </td>
                        {/* <td>
                          {getFieldData(
                            item.performerData,
                            "projectengagement",
                            "AgencyName"
                          )}
                        </td> */}
                        <td className="pb-0">
                          <button
                            className="btn btn-link btn-sm p-0"
                            onClick={() =>
                              handleViewShowHide("agency")
                            }
                          >

                            {getFieldData(
                              item.performerData,
                              "projectengagement",
                              "AgencyName"
                            )}
                          </button>
                          {item.rates &&
                            !isNaN(item.rates.agencyRate) &&
                            item.rates.agencyRate !== null
                            ? <><br />Rate : <b>${parseFloat(item.rates.agencyRate).toFixed(2)}/Hr</b></>
                            : ""}
                          <br />
                          {getAdminAgencyFee(item)}
                        </td>
                        <td>
                          {getFieldData(
                            item.performerData,
                            "projectengagement",
                            "EngagementDuration"
                          )}{" "}
                          Months
                          <br />
                          Start :{" "}
                          {
                            <Moment format="MMM Do YYYY">
                              {getFieldData(
                                item.performerData,
                                "projectengagement",
                                "StartDate"
                              )}
                            </Moment> ?
                              <Moment format="MMM Do YYYY">
                                {getFieldData(
                                  item.performerData,
                                  "projectengagement",
                                  "StartDate"
                                )}
                              </Moment> :
                              "NA"

                          }

                          <br />
                          End :{" "}
                          {
                            <Moment format="MMM Do YYYY">
                              {getFieldData(
                                item.performerData,
                                "projectengagement",
                                "EndDate"
                              )}
                            </Moment> ?
                              <Moment format="MMM Do YYYY">
                                {getFieldData(
                                  item.performerData,
                                  "projectengagement",
                                  "EndDate"
                                )}
                              </Moment> : "NA"
                          }
                        </td>
                        <td>
                          {item.appSubmit && (
                            <span className="btn btn-sm p-0">
                              Done
                            </span>
                          )}
                          {!item.appSubmit && (
                            <span className="btn btn-smp-0">
                              Pending
                            </span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              {viewType !== "" &&
                <div className="p-3 border mt-2">
                  <ViewCandidate
                    viewShowHide={viewShowHide}
                    handleDurationShowHide={handleDurationShowHide}
                    selectedObj={item}
                    viewType={viewType}
                  ></ViewCandidate>
                </div>}
              {wfForm && viewFormType !== "" &&
                <div className="p-3 border mt-2">
                  <div className="text-left mb-3 pr-0">
                    <button
                      className="btn btn-sm btn-outline-default mb-4"
                      onClick={() => handleViewcandidateForm(`${viewFormType}`, null)}
                    >
                      <i className="fa fa-times mr-2"></i>Close
                    </button>
                  </div>
                  <WorkflowElement
                    wfTask={wfTask}
                    wfForm={wfForm}
                    handleNextTask={handleNextTask}
                    viewType={true}
                    appSummary={false}
                    codeVerified={true}
                    wfTaskType={"form"}
                    // actionType={"workflow"}
                    updatedStateData={updatedStateData}
                  />
                </div>}
            </div>
            <div className="col-md-12">
              <div className="card card-body p-3 shadow-none border">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="year" className="form-control-label">
                      Year
                    </label>
                    <select
                      name="filterYear"
                      id="year"
                      className="form-control form-control-sm"
                      value={filterYear}
                      onChange={({ currentTarget }) => setFilterYear(currentTarget.value)}
                    >
                      <option value="">All</option>
                      {years.map((y) => (
                        <option value={y.name}>{y.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="month" className="form-control-label">
                      Month
                    </label>
                    <select
                      name="filterMonth"
                      id="month"
                      className="form-control form-control-sm"
                      value={filterMonth}
                      onChange={({ currentTarget }) => setFilterMonth(currentTarget.value)}
                    >
                      <option value="">All</option>
                      {months.map((m) => (
                        <option value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table align-items-center table-flush table-striped mb-2 border">
                  <thead className="thead-light">
                    <tr>
                      <th>Year</th>
                      <th>Month</th>
                      <th>Period
                        <br />
                        Time Logged</th>
                      <th>Hrs<br />Days</th>
                      <th>Rate/Hr ($)</th>
                      <th>Invoice<br />Amount ($)</th>
                      <th>Invoice</th>
                      <th>IPCS REVIEW <br />ADJUSTMENT (+,-)</th>
                      <th>Final<br />Pay Amount ($)</th>
                      <th>Payment</th>
                      {/* <th>Due Amount</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {timeLogs.map((item) => (
                      <tr>
                        <td>{item.year}</td>
                        <td>{getMonthName(item.month)}</td>
                        <td>
                          {getMonthlyPeriod(item)}

                          <button
                            className="btn btn-sm btn-link pl-0"
                            onClick={() => handleShowHide(item)}
                          >
                            View
                          </button>
                          <br />
                          {item.docList.map((doc) => (
                            <li className="list-group-item p-0 border-0 bg-transparent">
                              <button
                                className="btn btn-sm btn-link pl-0"
                                onClick={() => handleDownloadFile(doc)}
                              >
                                {doc.documentName.length > 15
                                  ? doc.documentName.substring(0, 15) + "..."
                                  : doc.documentName}
                              </button>
                            </li>
                          ))}
                        </td>

                        <td>
                          {getTotalHours(item.workingHrs)}
                          <br />
                          {getTotalDays(item.workingHrs) + " Days"}
                        </td>
                        <td>
                          {rate}
                          <br />
                          {rateDate && (
                            <Moment format="MM/DD/YYYY">{rateDate}</Moment>
                          )}
                        </td>

                        <td>
                          {getInvoiceAmount(item)}
                        </td>

                        <td>
                          {getInvoiceDocs(item)}
                        </td>

                        <td>
                          {getInvoiceStatus(item)}
                        </td>
                        <td>
                          {getFinalAmout(item)}
                        </td>
                        <td>
                          {getPaymentStatus(item)}
                        </td>
                        {/* <td>
                          {getDueAmountStatus(item)}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        candidateObj={candidateObj}
        selectedObj={timeLogObj}
        invType={invoiceType}
        timeLogInvoices={timeLogInvoices}
        getInvoiceAmount={getInvoiceAmount}
        entType={entType}
      ></CandidatePay>

      <InvoiceReview
        invRevShowHide={invRevShowHide}
        handleInvRevShowHide={handleInvRevShowHide}
        candidateObj={candidateObj}
        selectedObj={timeLogObj}
        invType={invoiceType}
        timeLogInvoices={timeLogInvoices}
        getInvoiceAmount={getInvoiceAmount}
        entType={entType}
      ></InvoiceReview>

      <AddNewTimeLog
        showHide={timeLogShowHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        timeLogs={timeLogs}
        allTimeLogs={timeLogs}
        candidateObj={candidateObj}
        timeLogInvoices={timeLogInvoices}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNoteShowHide}
        notesType={notesType}
        candidateObj={candidateObj}
        timeLogObj={timeLogObj}
      ></AddEditNotes>
    </React.Fragment>
  );
}
